// extracted by mini-css-extract-plugin
export default {"video_box":"index_video_box_gc3iD","video":"index_video_j83Hd"};